export const imageUrl = process.env.REACT_APP_IMAGE_URL;
